import React from 'react'
import SupportPrivacyPolicy from '../support-privacy-policy'

const SupportPrivacyPolicyDe = () => {
    return <SupportPrivacyPolicy languageCode="de" />
}

export default SupportPrivacyPolicyDe
